<div>
  @if (nodes && totalRecords) {
    <p-dataView #dv [value]="nodes" [lazy]="true"
    (onLazyLoad)="onLazyLoad($event)" [totalRecords]="totalRecords" [rows]="rows" [paginator]="true">
      <ng-template #list let-nodes>
        @for (nodeMapping of nodes; track $index) {
          <p-panel [toggleable]="true">
            <ng-template pTemplate="header">
              <div class="flex gap-2 align-items-center">
                <span class="font-bold">{{ nodeMapping.vendorAttribute }}</span>
              </div>
            </ng-template>
            <ng-template pTemplate="body">
              <div class="grid">
                @for (node of nodeMapping.details; track $index) {
                  <div class="col-5 m-auto">
                    <div class="line-wrapper">
                      <span>{{ node?.vendorValue }} </span>
                      <div class="line"></div>
                    </div>
                  </div>
                  <div class="col-5 m-auto">
                    <div class="flex">
                      <div class="flex-auto">
                        <p-select
                          [ngModel]="findMatchingOption(node.mappedValue, nodeMapping)"
                          (ngModelChange)="updateMappedValue($event, node)"
                          [options]="nodeMapping.values"
                          optionLabel="valueLabel"
                          valueLabel="valueLabel"
                          class="w-full"
                          [filter]="true"
                          filterBy="valueLabel"
                          placeholder="{{ 'mapping.chooseValue' | translate }}"
                          emptyMessage="{{ 'primeng.emptyMessage' | translate }}"
                          emptyFilterMessage="{{ 'primeng.emptyFilterMessage' | translate }}"
                          [disabled]="node.associated">
                        </p-select>
                      </div>
                    </div>
                  </div>
                  <div class="col-2 text-right">
                    <div class="line-wrapper">
                      <div class="line text-500"></div>
                      @if (node.associated) {
                        <p-button [severity]="'success'" [disabled]="true">
                          <i class="pi pi-check mr-1"></i> {{ "buttons.associated" | translate }}
                        </p-button>
                      } @else {
                        <p-button (click)="associate(node, nodeMapping)" [disabled]="node.mappedValue == ''">
                          <i class="pi pi-link mr-1"></i> {{ "buttons.associate" | translate }}
                        </p-button>
                      }
                    </div>
                  </div>
                }
              </div>
            </ng-template>
          </p-panel>
        }
      </ng-template>
    </p-dataView>
  }@else if(totalRecords === 0){
    <div class="flex justify-content-center mt-5">
      <p-message severity="info"  [closable]="false">
        <ng-template #icon>
          <i class="pi pi-info-circle" style="font-size: 1.5rem"></i>
        </ng-template>
        <div class="pl-2" [innerHTML]="'mapping.NoMappingValueMsg' | translate"></div>
      </p-message>
    </div>
  }
</div>
